<template>
    <card class='novo-emprestimo' title='Nova Reserva'>
        <form @submit.prevent.stop='submit()'>
            <div class='row'>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Membro</label>
                        <multiselect @remove='update' @input='update' track-by='id' label='name' v-model="emprestimo.membro" :options="membros" :allow-empty="false"></multiselect>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Obra</label>
                        <multiselect @remove='update' @input='update' track-by='id' label='name' v-model="emprestimo.obra" :options="obras" :allow-empty="false"></multiselect>
                    </div>
                </div>
            </div>
            <div class="text-center">
                <button type="submit" class="btn btn-info btn-fill btn-wd">Salvar</button>
            </div>
        </form>
    </card>
</template>
<script>
import MembrosService from '../../services/membros-service'
import Multiselect from 'vue-multiselect'
import ObraService from '../../services/obra-service'
import ReservaService from '../../services/reserva-service'
import OverlayService from '../../services/overlay-service'
import { mapState } from 'vuex'

export default {
  components: {
    Multiselect
  },

  computed: {
    ...mapState([
      'membros',
      'obras'
    ])
  },

  data () {
    return {
      emprestimo: this.clearEmprestimo()
    }
  },

  mounted () {
  },

  methods: {

    clearEmprestimo () {
      return {}
    },

    submit () {
      const toSave = JSON.parse(JSON.stringify(this.emprestimo))

      if (!toSave.obra) {
        this.$alertify.error('Selecione a Obra')
        return
      }

      if (!toSave.membro) {
        this.$alertify.error('Selecione o Membro')
        return
      }

      toSave.obra_id = toSave.obra.id
      toSave.emprestado_para = toSave.membro.id
      delete toSave.membro
      delete toSave.obra
      toSave.membro = toSave.emprestado_para
      delete toSave.emprestado_para

      OverlayService.trigger('show', true)

      ReservaService.nova(toSave)
        .then(emprestimo => emprestimo.data)
        .then(emprestimo => {
          OverlayService.trigger('show', false)
          this.$alertify.success('Reserva Criada Com Sucesso!')

          this.emprestimo = this.clearEmprestimo()
          this.$emit('new')
        }).catch(er => {
          let message = 'Erro ao criar reserva'

          if (er.response.data.message) {
            message = this.$t(er.response.data.message)
          }
          this.$alertify.error(message)
          OverlayService.trigger('show', false)
        })
    },

    update () {
      this.$forceUpdate()
    },
  }
}
</script>
<style scoped>
.novo-emprestimo {
  z-index: 2;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

